import type { Budget, Transaction } from '../types';

export type BudgetUsage = Budget & {
  spent: number;
  remaining: number;
  usagePct: number;
  state: 'safe' | 'warning' | 'crossed';
};

export const budgetNotificationKey = (category: string, monthKey: string) =>
  category.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '') + '_' + monthKey;

export function buildBudgetUsage(budgets: Budget[], transactions: Transaction[]) {
  const expenses = transactions.filter((row) => row.type === 'Expense' && row.status !== 'deleted' && row.active !== false);
  return budgets
    .filter((budget) => budget.status !== 'deleted' && budget.active !== false)
    .map((budget) => {
      const spent = expenses
        .filter((row) => row.category.toLowerCase() === budget.category.toLowerCase())
        .reduce((total, row) => total + Number(row.amount || 0), 0);
      const usagePct = budget.limitAmount > 0 ? Math.round((spent / budget.limitAmount) * 100) : 0;
      const state: BudgetUsage['state'] = usagePct >= 100 ? 'crossed' : usagePct >= 80 ? 'warning' : 'safe';
      return { ...budget, spent, remaining: budget.limitAmount - spent, usagePct, state };
    });
}
